import { useTranslation } from 'react-i18next';
import {
  CardLink,
  CardTitle,
  Container,
  SuggestionTitle,
  Title,
} from './styles';
import { Card, Col, Flex, Row, Space, Tabs, Typography } from 'antd';
import Icon, { RightOutlined } from '@ant-design/icons';
import { SVGFlow, SVGTemplate, SVGMachine } from '../../../images';
import { useTheme } from 'styled-components';
import Issues from './issues';
import { useSelector } from 'react-redux';
import {
  fetchNotifications,
  selectNotificationCauses,
  selectNotificationIssues,
  selectNotificationRoutines,
} from '../../../slices/notifications';
import Causes from './causes';
import Routines from './routines';
import { useEffect } from 'react';
import { useAppDispatch } from '../../../store';

const bannerCards = [
  {
    key: 'template',
    title: 'template',
    icon: SVGTemplate,
    links: [
      { title: 'template_add_new', link: 'template/add' },
      { title: 'template_existing', link: 'template' },
    ],
  },
  {
    key: 'machine',
    title: 'machine',
    icon: SVGMachine,
    links: [
      { title: 'machine_add_new', link: 'machine/add' },
      { title: 'machine_existing', link: 'machine' },
    ],
  },
  {
    key: 'flow',
    title: 'flow',
    icon: SVGFlow,
    disabled: true,
    links: [
      { title: 'flow_add_new', link: 'flow/add' },
      { title: 'flow_existing', link: 'flow' },
    ],
  },
];

const Knowledge = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useAppDispatch();

  const issues = useSelector(selectNotificationIssues);
  const causes = useSelector(selectNotificationCauses);
  const routines = useSelector(selectNotificationRoutines);

  useEffect(() => {
    dispatch(fetchNotifications());
  }, []);

  const tabs = [
    {
      key: 'issues',
      label: t('issues'),
      children: <Issues issues={issues} />,
    },
    {
      key: 'causes',
      label: t('causes'),
      children: <Causes causes={causes} />,
    },
    {
      key: 'routines',
      label: t('routines'),
      children: <Routines routines={routines} />,
    },
  ];

  return (
    <Container vertical gap={20}>
      <Title>{t('knowledge_base')}</Title>
      <Row gutter={36}>
        {bannerCards.map((banner) => (
          <Col key={banner.key} span={8}>
            <Card
              hoverable
              title={
                <Flex align="center" gap={16}>
                  <Icon
                    component={banner.icon}
                    style={{
                      fontSize: 32,
                      color: banner.disabled
                        ? theme.antd.colorTextSecondary
                        : theme.antd.colorPrimary,
                    }}
                  ></Icon>
                  <CardTitle className={banner.disabled ? 'disabled' : ''}>
                    {t(banner.title)}
                  </CardTitle>
                  {/* <RightOutlined style={{ width: 12, color: '#c6c8ca' }} /> */}
                </Flex>
              }
            >
              <Space size={16} direction="vertical">
                {banner.links.map((link) =>
                  banner.disabled ? (
                    <Typography.Text key={link.title} type="secondary">
                      {t(link.title)}
                    </Typography.Text>
                  ) : (
                    <CardLink key={link.title} to={link.link}>
                      {t(link.title)}
                    </CardLink>
                  )
                )}
              </Space>
            </Card>
          </Col>
        ))}
      </Row>
      <SuggestionTitle>{t('knowledge_base_suggestion_view')}</SuggestionTitle>

      <Tabs
        onChange={() => {}}
        type="card"
        tabBarGutter={40}
        className="tabs"
        items={tabs}
      />
    </Container>
  );
};

export default Knowledge;
